import { NotificationsActive } from "@mui/icons-material";
import styled from "styled-components";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

const AlertContainer = styled.div`
  bottom: 3%;
  right: 1rem;
  width: 25rem;
  position: absolute;
  background: rgba(118, 120, 138, 0.2);
  backdrop-filter: blur(10px);
  display: ${({ $showalert }) => ($showalert ? 'flex' : 'none')};
  border-radius: 8px;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  gap: 1rem;
  padding: 1rem;
  transition: all 0.2s ease-in-out;
`;

const AlertNotification = ({ handleOpen, notificatDescript, handleCloseNotifications }) => {
  const navigate = useNavigate()
  return (
    <AlertContainer
      $showalert={handleOpen}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        navigate(notificatDescript?.path)
        handleCloseNotifications()
        }}>
      <NotificationsActive style={{ color: "#ffc400", fontSize: "2rem" }} />
      <div className={styles.container__texts}>
        <h1>Nova notificação recebida!</h1>
        <span>{notificatDescript?.text}</span>
      </div>
    </AlertContainer>
  );
};

export default AlertNotification;
